import React from "react";
import Moment from "react-moment";
import "moment-timezone";

const format = "DD-MM-YYYY HH:mm:ss";
const dateFormat = "DD-MM-YYYY";
const tz = "Europe/Kiev"

const TimestampToDateMoment = (str, momentFormat = format) => {
  return <Moment format={momentFormat} tz={tz}>{new Date(str * 1000)}</Moment>;
};

const DateToFormat = (str) => {
  return <Moment format={format}>{str}</Moment>;
};

const DateToTimestamp = (date) => {
  return date ? (Date.parse(date) / 1000).toString() : "";
};

const getStartOfDayFromDate = (date) => {
  return date ? (new Date(date).setHours(0,0,0) / 1000) : "";
}

const getEndOfDayFromDate = (date) => {
  return date ? (new Date(date).setHours(23,59,59) / 1000) : "";
}

const MillisecondsToTimestamp = (date, endOfDay = false) => {
  if (date && endOfDay) {
    date.setHours(23, 59, 59, 999);
  }

  return date ? (Date.parse(date)).toString() : "";
};

const TimestampToDate = (date) => {
  return date ? new Date(date * 1000) : "";
};

const firstDayOfMonth = () => {
  return (Date.parse(new Date(new Date().getFullYear(), new Date().getMonth(), 1)) / 1000).toString();
};

const lastDayOfMonth = () => {
  return (Date.parse(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)) / 1000).toString();
};

export {
  dateFormat,
  TimestampToDateMoment,
  DateToFormat,
  DateToTimestamp,
  TimestampToDate,
  firstDayOfMonth,
  lastDayOfMonth,
  MillisecondsToTimestamp,
  getStartOfDayFromDate,
  getEndOfDayFromDate
};
